import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OutlookLoginService } from '../../services';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoginComponent {

    public form: UntypedFormGroup;
    public message: string;

    constructor(
        private outlookLogin: OutlookLoginService) {
    }

    onLogin() {
        this.outlookLogin.showLogin();
    }
}

